import { useContext, useEffect, useState } from "react";
import { LocaleContext } from "../../contexts/LocaleContext";
import DailyBookings from "../../components/charts/MonthlyBookings.jsx";
import MonthlyRevenue from "../../components/charts/MonthlyRevenue";
import NewUsersDaily from "../../components/charts/MonthlyNewUsers.jsx";
import DashboardStatistics from "./components/DashboardStatistics";
import { dashboardService } from "../../services/dashboardService.js";
import { toast } from "../../services/toastService.js";
import Loading from "../../components/common/Loading.jsx";
import MonthlyBookings from "../../components/charts/MonthlyBookings.jsx";
import CategoryStatistics from "./components/CategoryStatistics.jsx";
import MonthlyNewUsers from "../../components/charts/MonthlyNewUsers.jsx";
import CityStatistics from "./components/CityStatistics.jsx";
import LatestBooking from "./components/LatestBooking.jsx";
import LoadingData from "../../components/common/LoadingData.jsx";

const Dashboard = () => {
  const { t,lang } = useContext(LocaleContext);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(()=>{
    getDashboardData();
  },[]);

  const getDashboardData = async () => {
    try {
      setLoading(true);
      const response = await dashboardService.getStatisticsAsync();
      console.log(response);

      if(!response.isSuccess){
        console.log(response);
        toast.error(t("anErrorOccurredPleaseTryAgainLater"));
        return;
      }
      setData(response.value);
      // Process the data as needed
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
    finally {
      setLoading(false);
    }
  };

  if (loading) return  <LoadingData t={t} />;

  return (
    <section className="section-dashboard">
      <div className="default-heading">{t("dashboard")}</div>
      <DashboardStatistics
        t={t}
        booking={data?.booking}
      />
      <section className="section-dashboard-charts">
        <div className="row g-3">
          <div className="col-12 col-xl-7">
            <div className="chart-card">
              <MonthlyRevenue
                title={t("monthlyRevenue")}
                height={400}
                thisYear={data?.monthlyRevenue?.thisYear}
                lastYear={data?.monthlyRevenue?.lastYear}
              />
            </div>
          </div>
          <div className="col-12 col-xl-5">
            <div className="chart-card">
              <MonthlyBookings title={t("monthlyBookings")} height={400} monthlyBooking={data?.monthlyBooking} />
            </div>
          </div>
          <div className="col-12 col-xl-6">
            <CategoryStatistics t={t} lang={lang} category={data?.categoryStatistics} />
          </div>
           <div className="col-12 col-xl-6">
           <LatestBooking t={t} lang={lang} latestBookings={data?.latestBookings} />
          </div>
          <div className="col-12 col-xl-12">
            <CityStatistics t={t} lang={lang} cityStatistics={data?.cityStatistics} />
          </div>
        </div>
      </section>
    </section>
  );
};

export default Dashboard;
